var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "56px",
    viewBox: "0 0 35 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "functionality-playicon",
    transform: "translate(-322.000000, -388.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "element-play",
    transform: "translate(273.000000, 356.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49,33.177543 L49,86.9604097 C49,87.5126944 49.4477153,87.9604097 50,87.9604097 C50.2217068,87.9604097 50.4371275,87.8867322 50.6123977,87.7509595 L83.5312213,62.2504624 C83.9678299,61.9122444 84.0475913,61.2841234 83.7093734,60.8475148 C83.6681196,60.79426 83.6215902,60.7453099 83.5704943,60.7014106 L50.6516707,32.419041 C50.2327616,32.0591332 49.6014058,32.1069632 49.241498,32.5258723 C49.0856771,32.7072377 49,32.9384331 49,33.177543 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.e33ae8ccf2e7982d0f154c8fc4f35b00.svg";
export { ForwardRef as ReactComponent };